module.exports = __webpack_public_path__ + "img/arrow_left_dark.5007df1f.svg";